import NumberInput from '@rio-cloud/rio-uikit/components/numberInput/NumberInput';
import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import classNames from 'classnames';
import { forwardRef, type InputHTMLAttributes } from 'react';
import { type Control, useController } from 'react-hook-form';

import { ValidationViolation } from './ValidationViolation.tsx';

type CoordinatesInputProps<Element = InputHTMLAttributes<HTMLInputElement>> = Element & {
    error?: string | string[] | false;
    // biome-ignore lint/suspicious/noExplicitAny: <react-hook-form> types
    control?: Control<any>;
    name: string;
    formGroupClassName?: string;
    max?: number;
    min?: number;
    step?: number;
    value?: number | undefined;
    onChange?: (value: number | undefined) => number | undefined;
    disabled?: boolean;
    label?: string;
};

export const CoordinateInput = forwardRef<HTMLInputElement, CoordinatesInputProps>(
    ({ control, error, name, formGroupClassName, disabled = false, label, ...props }, ref) => {
        const { field, fieldState } = useController({ control, name });
        const hasViolation = !!fieldState.error;

        return (
            <div
                className={classNames(formGroupClassName, {
                    'has-error': hasViolation,
                    'has-feedback': hasViolation,
                })}
            >
                {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
                <div className='input-group'>
                    <div className='form-control-feedback-wrapper'>
                        <NumberInput
                            {...field}
                            {...props}
                            id={name}
                            name={name}
                            ref={ref}
                            digitPrecision={13}
                            min={-180}
                            max={180}
                            disabled={disabled}
                        />
                    </div>
                </div>
                <ValidationViolation violations={error ?? fieldState.error?.message} />
            </div>
        );
    }
);
